import type { QueryClient } from '@tanstack/react-query';
import { CONTENT_TRACKING_KEYS } from '@/marketing/infrastructure/influencer/campaign/contentTracking/utils/keys';
import { CAMPAIGN_PIPELINE_KEYS } from '@/marketing/infrastructure/influencer/campaign/pipeline/utils/keys';
import { CAMPAIGN_ACTIVITY_KEYS } from '@/marketing/infrastructure/influencer/campaign/activity/utils/keys';

// Await active reads before allowing another edit with an enrollment's content version.
export async function invalidateContentQueries(queryClient: QueryClient): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: CONTENT_TRACKING_KEYS.lists() }),
    queryClient.invalidateQueries({ queryKey: CAMPAIGN_PIPELINE_KEYS.lists() }),
    queryClient.invalidateQueries({ queryKey: CAMPAIGN_ACTIVITY_KEYS.all }),
  ]);
}
